import { render, staticRenderFns } from "./ModalPreview.vue?vue&type=template&id=c0a5e280&scoped=true"
import script from "./ModalPreview.vue?vue&type=script&lang=js"
export * from "./ModalPreview.vue?vue&type=script&lang=js"
import style0 from "./ModalPreview.vue?vue&type=style&index=0&id=c0a5e280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a5e280",
  null
  
)

export default component.exports